// import React, { useState, useEffect, useMemo, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import { UnsavedContext } from "../MainLayout";
// import CheckIcon from "@mui/icons-material/Check";
// import {
//   Box,
//   Typography,
//   Avatar,
//   Menu,
//   MenuItem,
//   Button,
//   List,
//   ListItem,
//   ListItemText,
//   ListItemButton,
//   Paper,
//   RadioGroup,
//   FormControlLabel,
//   Radio,
//   Divider,
//   Snackbar,
//   Alert,
//   LinearProgress,
//   CircularProgress,
// } from "@mui/material";
// import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
// import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
// import { useLocation, useParams } from "react-router-dom";
// import logo from "../../assets/images/logo.png";
// import { motion, AnimatePresence } from "framer-motion";
// import signup from "../../assets/images/background.png";
// import Notification from "../Notification";
// // import AssessmentDialog from "../AssessmentDialog";
// import { useApi } from "../../api/useApi";
// import { useAuth } from "../../auth/AuthContext";
// import GlassLoaderOverlay from "../GlassLoader";
// import { useActiveCategory } from "../customHook/useActiveCategory";

// const SuccessBanner = ({ open, message }) => {
//   return (
//     <AnimatePresence>
//       {open && (
//         <motion.div
//           initial={{ y: 50, opacity: 0 }}
//           animate={{ y: 0, opacity: 1 }}
//           exit={{ y: 50, opacity: 0 }}
//           transition={{ duration: 0.4, ease: "easeOut" }}
//           style={{
//             position: "fixed",
//             bottom: "2rem", // stay at bottom
//             left: "35%", // center horizontally
//             transform: "translateX(-50%)", // perfectly center it
//             display: "inline-flex",
//             alignItems: "center",
//             gap: "1rem",
//             borderRadius: "1rem",
//             border: "1px solid #00A300",
//             background: "#016100",
//             color: "#FFFFFF",
//             // fontFamily: "Akkurat-Bold, sans-serif",
//             fontSize: "0.9rem",
//             fontWeight: 400,
//             padding: "0.75rem 1.25rem",
//             zIndex: 2000,
//             boxShadow: "0 2px 10px rgba(0, 0, 0, 0.25)",
//             textAlign: "center",
//             maxWidth: "90%",
//             fontFamily: "Akkurat",
//           }}
//         >
//           {/* ✅ Green Tick Icon */}
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             width="20"
//             height="20"
//             viewBox="0 0 20 20"
//             fill="none"
//           >
//             <path
//               fillRule="evenodd"
//               clipRule="evenodd"
//               d="M10 1.25C5.125 1.25 1.25 5.125 1.25 10C1.25 14.875 5.125 18.75 10 18.75C14.875 18.75 18.75 14.875 18.75 10C18.75 5.125 14.875 1.25 10 1.25ZM8.75 13.75L5.375 10.375L6.5 9.375L8.75 11.625L13.75 6.75L14.875 7.75L8.75 13.75Z"
//               fill="#24A148"
//             />
//           </svg>

//           {/* ✅ Message Text */}
//           <span>{message}</span>
//         </motion.div>
//       )}
//     </AnimatePresence>
//   );
// };
// const Questions = () => {
//   const { domain } = useParams();
//   const [categories, setCategories] = useState([]);
//   const { request, loading } = useApi();
//   const { user } = useAuth();
//   const [questions, setQuestions] = useState([]);
//   const [answers, setAnswers] = useState({});
//   const [categoryIndex, setCategoryIndex] = useState(0);
//   const [categoryStatus, setCategoryStatus] = useState({});
//   const [progress, setProgress] = useState(0);
//   const [evaluationId, setEvaluationId] = useState(null);
//   const [notif, setNotif] = useState({
//     open: false,
//     success: true,
//     text: "",
//   });
//   const scrollRef = useRef(null);

//   const navigate = useNavigate();
//   const [showSuccessBanner, setShowSuccessBanner] = useState(false);
//   const [bannerMessage, setBannerMessage] = useState("");
//   const [dataLoaded, setDataLoaded] = useState(false);
//   const { hasUnsaved, setHasUnsaved } = React.useContext(UnsavedContext);
//   const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
//   const [isCategoriesReady, setIsCategoriesReady] = useState(false);
//   const [isLastCategoryReady, setIsLastCategoryReady] = useState(false);
//   const activeCategory = useActiveCategory();

//   const location = useLocation();

//   const {
//     resume,
//     evaluationId: navEvaluationId,
//     categoryIndex: navCategoryIndex,
//   } = location.state || {};

//   useEffect(() => {
//     const handleBeforeUnload = (event) => {
//       if (hasUnsaved) {
//         // Show browser default warning popup
//         event.preventDefault();
//         event.returnValue = "";

//         // Show your custom warning banner (bottom red banner)
//         setNotif({
//           open: true,
//           success: false,
//           text: "You have unsaved changes. Please click SAVE before continuing.",
//         });
//       }
//     };

//     window.addEventListener("beforeunload", handleBeforeUnload);
//     return () => window.removeEventListener("beforeunload", handleBeforeUnload);
//   }, [hasUnsaved]);

//   useEffect(() => {
//     async function fetchCategories() {
//       try {
//         const categories = await request({ url: "/domains-with-categories" });
//         const categoriesByDomain =
//           categories.find((d) => d.name.toLowerCase() === domain.toLowerCase())
//             ?.categories || [];
//         const sortByWeightage = categoriesByDomain.sort((a, b) => {
//           if (b.weightage !== a.weightage) return b.weightage - a.weightage;
//           return a.name.localeCompare(b.name);
//         });

//         setCategories(sortByWeightage);
//         setIsCategoriesReady(true);
//       } catch (err) {
//         console.error("Error fetching categories:", err);
//       }
//     }

//     fetchCategories();
//   }, [domain]);

//   useEffect(() => {
//     async function fetchAllData() {
//       try {
//         // 🧹 Reset data before loading new domain — but don't reset categoryIndex
//         setDataLoaded(false);
//         setQuestions([]);
//         setAnswers({});
//         setProgress(0);
//         const storedEvalId = localStorage.getItem(`evaluationId_${domain}`);
//         if (storedEvalId) {
//           setEvaluationId(storedEvalId);
//         }
//         // ⭐ Restore evaluationId from localStorage FIRST
//         // const storedEvalId = localStorage.getItem("evaluationId");
//         if (storedEvalId) {
//           setEvaluationId(storedEvalId);
//         }

//         // Step 1: Fetch user details
//         const users = await request({
//           url: `/user/by-email?email=${user?.email}`,
//         });

//         const userRole = users?.[0]?.userRole;
//         const userDomain = users?.[0]?.domain;
//         const userDomainRole = users?.[0]?.userDomain;
//         // Step 2: Fetch questions
//         const questionsData = await request({
//           url: `/questions/filter?userRole=${encodeURIComponent(
//             userRole,
//           )}&domain=${encodeURIComponent(domain)}&userDomainRole=${encodeURIComponent(userDomainRole)}`,
//         });

//         const freshQuestions = questionsData?.questions || [];
//         const latestCompletedData = await request({
//           url: `/evaluations/latest-completed-answers?emailId=${encodeURIComponent(
//             user?.email,
//           )}&domain=${encodeURIComponent(domain)}`,
//         });

//         // Step 3: Fetch resume data
//         const resumeData = await request({
//           url: `/evaluations/evaluation/progress?emailId=${encodeURIComponent(
//             user?.email,
//           )}&domain=${encodeURIComponent(domain)}`,
//         });

//         const savedData =
//           latestCompletedData?.found && !resumeData?.resumeAvailable
//             ? latestCompletedData
//             : resumeData || {};
//         const answersMap = {};
//         if (latestCompletedData?.found && !resumeData?.resumeAvailable)
//           localStorage.setItem(
//             `resumeLastCategory_${domain}`,
//             latestCompletedData?.allCategories[0],
//           );

//         if (savedData?.resumeAvailable) {
//           localStorage.setItem("resumeAvailable", "true");
//         } else {
//           localStorage.removeItem("resumeAvailable");
//         }

//         // Step 4: If resuming, restore previous state
//         if (savedData?.questionsByCategory) {
//           Object.values(savedData.questionsByCategory).forEach(
//             (categoryQuestions) => {
//               categoryQuestions.forEach((q) => {
//                 if (
//                   q.questionId &&
//                   q.selectedOption !== undefined &&
//                   q.selectedOption !== null
//                 ) {
//                   answersMap[q.questionId] = q.selectedOption;
//                 }
//               });
//             },
//           );

//           setEvaluationId(savedData.evaluationId);
//           setAnswers(answersMap);
//           setIsLastCategoryReady(true);

//           // setCategoryIndex(
//           //   typeof savedData.categoryIndex === "number"
//           //     ? savedData.categoryIndex
//           //     : 0
//           // );

//           console.log(
//             "🟢 Resuming evaluation",
//             savedData.evaluationId,
//             "at category index",
//             savedData.categoryIndex,
//           );
//         } else {
//           // New user → start fresh
//           setProgress(0);
//           setCategoryIndex(0);
//         }

//         setQuestions(freshQuestions);
//       } catch (err) {
//         console.error("Error fetching evaluation data:", err);
//       } finally {
//         setDataLoaded(true);
//       }
//     }

//     if (user?.email && domain) {
//       fetchAllData();
//     }
//   }, [user.email, domain]);
//   useEffect(() => {
//     if (isCategoriesReady && isLastCategoryReady) {
//       const resumeLastCategory = localStorage.getItem(
//         `resumeLastCategory_${domain}`,
//       );
//       let activeStepindex = categories.findIndex(
//         (item) => item.name == resumeLastCategory,
//       );
//       setCategoryIndex(activeStepindex);
//     }
//   }, [isCategoriesReady, isLastCategoryReady]);
//   useEffect(() => {
//     let activeStepindex = categories.findIndex(
//       (item) => item.name == activeCategory,
//     );
//     setCategoryIndex(activeStepindex);
//   }, [activeCategory, categories]);
//   useEffect(() => {
//     if (!questions?.length) return;

//     // Group questions by category
//     const grouped = questions.reduce((acc, q) => {
//       if (!acc[q.category]) acc[q.category] = [];
//       acc[q.category].push(q);
//       return acc;
//     }, {});

//     // Calculate status for each category
//     const statusMap = {};

//     Object.keys(grouped).forEach((category) => {
//       const catQuestions = grouped[category];

//       const anyAnswered = catQuestions.some(
//         (q) =>
//           answers[q.questionId] !== undefined && answers[q.questionId] !== "",
//       );

//       const allAnswered = catQuestions.every(
//         (q) =>
//           answers[q.questionId] !== undefined && answers[q.questionId] !== "",
//       );

//       statusMap[category] = { anyAnswered, allAnswered };
//     });

//     setCategoryStatus(statusMap);
//     localStorage.setItem("categoryStatus", JSON.stringify(statusMap));
//     window.dispatchEvent(new Event("categoryStatusUpdated"));
//   }, [answers, questions]);

//   useEffect(() => {
//     if (!categories.length || !questions.length) return;

//     // Group questions by category
//     const grouped = categories.reduce((acc, cat) => {
//       acc[cat.name] = questions.filter((q) => q.category === cat.name);
//       return acc;
//     }, {});

//     let totalProgress = 0;
//     categories.forEach((cat) => {
//       const catQuestions = grouped[cat.name] || [];
//       if (catQuestions.length === 0) return;
//       const answeredCount = catQuestions.filter(
//         (q) => answers[q.questionId],
//       ).length;
//       const fraction = answeredCount / catQuestions.length;
//       totalProgress += fraction * cat.weightage;
//     });

//     setProgress(Math.round(totalProgress));
//   }, [answers, questions, categories]);

//   useEffect(() => {
//     if (scrollRef.current) {
//       scrollRef.current.scrollTo({
//         top: 0,
//         behavior: "smooth",
//       });
//     }
//   }, [categoryIndex]);

//   const currentCategory = categories[categoryIndex];

//   useEffect(() => {
//     if (!categories.length) return;

//     const cat = categories[categoryIndex];
//     if (cat) {
//       // Save active category
//       localStorage.setItem("activeCategory", cat.name);

//       // 🔥 Notify MainLayout immediately
//       window.dispatchEvent(new Event("activeCategoryChanged"));
//     }
//   }, [categoryIndex, categories]);

//   const currentCategoryQuestions = questions.filter(
//     (q) => q.category === currentCategory?.name,
//   );

//   // ⭐ Add this exactly here
//   const totalQuestions = currentCategoryQuestions.length;
//   const answeredCount = currentCategoryQuestions.filter(
//     (q) => answers[q.questionId],
//   ).length;

//   const handleSelectAnswer = (questionId, opt) => {
//     setAnswers((prev) => ({ ...prev, [questionId]: opt }));
//     setHasUnsaved(true);
//   };

//   const canSave = useMemo(() => {
//     if (!currentCategoryQuestions) return false;

//     return currentCategoryQuestions.some(
//       (q) =>
//         answers[q.questionId] !== undefined && answers[q.questionId] !== "",
//     );
//   }, [answers, currentCategoryQuestions]);

//   const canMoveNext = useMemo(() => {
//     if (!currentCategoryQuestions || currentCategoryQuestions.length === 0) {
//       return true;
//     }

//     return currentCategoryQuestions.every(
//       (q) =>
//         answers[q.questionId] !== undefined && answers[q.questionId] !== "",
//     );
//   }, [answers, currentCategoryQuestions]);

//   const handleNext = () => {
//     setCategoryIndex((idx) => Math.min(idx + 1, categories.length - 1));
//   };
//   const handleBack = () => setCategoryIndex((idx) => Math.max(idx - 1, 0));

//   const handleSaveOrSubmit = async (actionType = "save") => {
//     const activeCategory = localStorage.getItem("activeCategory");
//     try {
//       let transformedAnswers = [];

//       // Transform user answers into backend-friendly format
//       questions.forEach((q) => {
//         const selectedOption = answers[q.questionId];
//         if (selectedOption) {
//           const options = q.optionText
//             ? q.optionText.split(",").map((opt) => opt.trim())
//             : [];
//           const pointsArr = q.optionPoints
//             ? q.optionPoints.split(",").map((p) => parseFloat(p.trim()))
//             : [];
//           const recsArr = q.recommendation
//             ? q.recommendation.split("||").map((r) => r.trim())
//             : [];
//           const remarksArr = q.remarks
//             ? q.remarks.split(",").map((r) => r.trim())
//             : [];
//           const optionIndex = options.indexOf(selectedOption);

//           transformedAnswers.push({
//             questionId: q.questionId,
//             selectedOption,
//             points:
//               optionIndex !== -1 && pointsArr.length > optionIndex
//                 ? pointsArr[optionIndex]
//                 : 0,
//             recommendation:
//               optionIndex !== -1 && recsArr.length > optionIndex
//                 ? recsArr[optionIndex]
//                 : "not provided",
//             remarks:
//               optionIndex !== -1 && remarksArr.length > optionIndex
//                 ? remarksArr[optionIndex]
//                 : "",
//             //domain: domain,
//             domain: domain.toUpperCase(),
//             category: q.category || "Uncategorized",
//           });
//         }
//       });

//       // Prepare payload
//       const payload = {
//         emailId: user.email,
//         userName: user.name,
//         evaluationId: evaluationId,
//         answers: transformedAnswers,
//         isLastCategory: categoryIndex === categories.length - 1,
//         isSubmitAction: actionType === "submit",
//         currentCategory: activeCategory,
//         // ✅ ADD THESE TWO LINES
//         submittedAt: new Date().toLocaleString("sv-SE").replace(" ", "T"), // "2024-01-15T10:01:00"
//         timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
//       };
//       // Save or submit to backend
//       const response = await request({
//         url: `/evaluations/saveOrSubmit`,
//         method: "POST",
//         data: payload,
//       });

//       console.log("SAVE/SUBMIT RESPONSE →", response);

//       if (response?.evaluationId) {
//         setEvaluationId(response.evaluationId);
//         localStorage.setItem(`evaluationId_${domain}`, response.evaluationId);
//       }

//       const finalEvalId =
//         response?.evaluationId !== undefined && response?.evaluationId !== null
//           ? response.evaluationId
//           : evaluationId;

//       if (actionType === "submit") {
//         setBannerMessage(
//           "Congratulations! Your form has been successfully submitted for assessment.",
//         );
//         setShowSuccessBanner(true);

//         setTimeout(() => {
//           setShowSuccessBanner(false);

//           navigate(
//             `/final-page?evaluationId=${
//               response?.evaluationId || evaluationId
//             }&domain=${encodeURIComponent(domain)}&email=${encodeURIComponent(
//               user.email,
//             )}&name=${encodeURIComponent(user.name || "User")}`,
//           );
//         }, 2500);
//       } else {
//         setBannerMessage(
//           "Answers saved successfully. You can resume your assessment within 30 days. Thank you.",
//         );
//         setShowSuccessBanner(true);
//         setTimeout(() => setShowSuccessBanner(false), 3000);
//       }

//       setHasUnsaved(false);
//     } catch (error) {
//       console.error("Error saving or submitting:", error);
//     }
//   };

//   if (!dataLoaded) {
//     return <GlassLoaderOverlay open={true} />; // show spinner
//   }

//   if (dataLoaded && (!categories.length || !questions.length)) {
//     return (
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           width: "100%",
//           height: "70vh",
//           borderRadius: "2.5rem",
//           background: "rgba(255, 255, 255, 0.7)",
//         }}
//       >
//         <Typography
//           sx={{
//             fontFamily: "Akkurat-Bold",
//             fontSize: "1.25rem",
//             color: "#0036DD",
//             textAlign: "center",
//           }}
//         >
//           Assessment not available
//         </Typography>
//       </Box>
//     );
//   }

//   const handleNextOrWarn = () => {
//     if (!canMoveNext) {
//       const unanswered = currentCategoryQuestions
//         .filter((q) => !answers[q.questionId])
//         .map(
//           (q) =>
//             currentCategoryQuestions.findIndex(
//               (i) => i.questionId === q.questionId,
//             ) + 1,
//         )
//         .join(", ");

//       setNotif({
//         open: true,
//         success: false,
//         text: `Please answer all questions. Unanswered: Q${unanswered}`,
//       });
//       return;
//     }

//     if (categoryIndex === categories.length - 1 && canMoveNext) {
//       handleSaveOrSubmit("submit");
//       return;
//     }

//     // 3) Otherwise, move to next category
//     if (canMoveNext) {
//       handleNext();
//       return;
//     }

//     // 4) Fallback: warn about unsaved changes (if any)
//     if (hasUnsavedChanges) {
//       setNotif({
//         open: true,
//         success: false,
//         text: "You have unsaved changes. Please click SAVE before continuing.",
//       });
//       return;
//     }
//   };

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "flex-start",
//         gap: { xs: "1rem", sm: "1.25rem", md: "1rem" },
//         flex: "1 0 0",
//         borderRadius: { xs: "0.75rem", sm: "1rem", md: "1.25rem" },
//         height: { xs: "70vh", sm: "70vh", md: "70vh", lg: "84vh", xl: "86vh" },
//         border: "1px solid #ECECEC",
//         background: "#FFF",
//         margin: "20px",

//         padding: { xs: 0, sm: 0, md: 0, lg: 0, xl: 3 },
//       }}
//     >
//       <Box
//         sx={{
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "flex-start",
//           gap: "1rem",
//           padding: "1rem",
//           alignSelf: "stretch",
//           borderRadius: "2rem",
//           background: "rgba(255, 255, 255, 0.70)",
//           // height: "59vh",
//           // overflowY: "scroll", scrollbarWidth: "none",
//         }}
//       >
//         {/* Steps Of Categories*/}

//         <Box
//           sx={{
//             display: "flex",
//             padding: "0.75rem 1.5rem",
//             alignItems: "center",
//             gap: "1rem",
//             alignSelf: "stretch",
//             borderRadius: "0.5rem",
//             background: "var(--Background-Background-information, #EDF0FD)",
//           }}
//         >
//           <Typography
//             sx={{
//               color: "#0036DD",
//               fontFeatureSettings: "'liga' off, 'clig' off",
//               fontFamily: "Akkurat-Pro",
//               fontSize: {
//                 xs: "0.9rem",
//                 sm: "0.9rem",
//                 md: "0.9rem",
//                 lg: "1rem",
//                 xl: "1rem",
//               },
//               fontStyle: "normal",
//               fontWeight: 400,
//               lineHeight: "normal",
//             }}
//           >
//             Category :&nbsp;
//             <Box
//               component="span"
//               sx={{
//                 color: "#0036DD",
//                 fontFeatureSettings: "'liga' off, 'clig' off",
//                 fontSize: {
//                   xs: "0.9rem",
//                   sm: "0.9rem",
//                   md: "0.9rem",
//                   lg: "1rem",
//                   xl: "1rem",
//                 },
//                 fontFamily: "Akkurat-Bold",
//                 fontStyle: "normal",
//                 fontWeight: 400,
//                 lineHeight: "normal",
//               }}
//             >
//               {currentCategory?.name}

//               {/* {currentCategory?.name} - ({answeredCount}/{totalQuestions}) */}
//             </Box>
//           </Typography>
//         </Box>

//         {/* Questions */}
//         <Box
//           ref={scrollRef}
//           sx={{
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "flex-start",

//             width: {
//               xs: "100%",
//               sm: "100%",
//               md: "85%",
//               lg: "100%",
//               xl: "100%",
//             },

//             // maxWidth: "100%",

//             // width: "100%",
//             height: {
//               xs: "53vh",
//               sm: "53vh",
//               md: "53vh",
//               lg: "60vh",
//               xl: "70vh",
//             },

//             overflowY: "auto",
//             overflowX: "hidden",

//             "&::-webkit-scrollbar": {
//               width: "2px",
//             },
//             "&::-webkit-scrollbar-track": {
//               background: "transparent",
//             },
//             "&::-webkit-scrollbar-thumb": {
//               background: "rgba(0, 0, 0, 0.50)",
//               borderRadius: "1rem",
//             },
//             "&::-webkit-scrollbar-thumb:hover": {
//               background: "rgba(0, 0, 0, 0.50)",
//             },
//           }}
//         >
//           {currentCategoryQuestions.map((q, idx) => {
//             const options = q.optionText.split(",");
//             const isAnswered = answers[q.questionId] !== undefined;
//             return (
//               <Box
//                 key={q.questionId}
//                 sx={{
//                   display: "flex",
//                   alignItems: "flex-start",
//                   gap: "0.5rem",
//                   alignSelf: "stretch",
//                   // pl: { xs: 3, sm: 3, md: 3, lg: 0, xl: 3 },
//                 }}
//               >
//                 <Box
//                   sx={{
//                     width: "0.125rem",
//                     alignSelf: "stretch",
//                     background: isAnswered
//                       ? "#0036DD"
//                       : "var(--border-border-subtle-01, #E0E0E0)",
//                   }}
//                 />

//                 <Box
//                   sx={{
//                     display: "flex",
//                     flexDirection: "column",
//                     alignItems: "flex-start",
//                     gap: "1rem",
//                     paddingBottom: "1.5rem",
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       display: "flex",
//                       flexDirection: "column",
//                       alignItems: "flex-start",
//                       alignSelf: "stretch",
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         display: "flex",
//                         flexDirection: "column",
//                         alignItems: "flex-start",
//                         height: "1.125rem",
//                         marginBottom: "0.5rem",
//                       }}
//                     >
//                       <Typography
//                         sx={{
//                           //color: "var(--text-text-primary, #161616)",
//                           color: "#525252",
//                           fontSize: {
//                             xs: "0.9rem",
//                             sm: "0.9rem",
//                             md: "0.9rem",
//                             lg: "16px",
//                             xl: "1rem",
//                           },
//                           fontFamily: "Akkurat",
//                           //fontSize: "0.875 rem",
//                           fontStyle: "normal",
//                           fontWeight: 400,
//                           lineHeight: "1.125rem",
//                           fontFeatureSettings: "'liga' off, 'clig' off",
//                         }}
//                       >
//                         {` ${idx + 1}. `}
//                         {q.question}
//                       </Typography>
//                     </Box>
//                   </Box>
//                   <Box
//                     sx={{
//                       display: "flex",
//                       flexDirection: "column",
//                       alignItems: "flex-start",
//                       gap: "1rem",
//                       height: "fit-content",
//                       alignSelf: "stretch",
//                     }}
//                   >
//                     {options.map((opt) => {
//                       const isSelected = answers[q.questionId] === opt;
//                       return (
//                         <Box
//                           key={opt}
//                           sx={{
//                             display: "flex",
//                             alignItems: "center",
//                             gap: "0.5rem",
//                             fontFamily: "Akkurat-Pro",
//                           }}
//                         >
//                           {!isSelected ? (
//                             <Box
//                               onClick={() =>
//                                 handleSelectAnswer(q.questionId, opt)
//                               }
//                               sx={{
//                                 width: "1.25rem",
//                                 height: "1.25rem",
//                                 flexShrink: 0,
//                                 m: 0,
//                                 p: 0,
//                                 cursor: "pointer",
//                               }}
//                             >
//                               <svg
//                                 xmlns="http://www.w3.org/2000/svg"
//                                 width="20"
//                                 height="20"
//                                 viewBox="0 0 20 20"
//                                 fill="none"
//                               >
//                                 <path
//                                   fillRule="evenodd"
//                                   clipRule="evenodd"
//                                   d="M10 1.25C5.16751 1.25 1.25 5.16751 1.25 10C1.25 14.8325 5.16751 18.75 10 18.75C14.8325 18.75 18.75 14.8325 18.75 10C18.75 7.67936 17.8281 5.45376 16.1872 3.81282C14.5462 2.17187 12.3206 1.25 10 1.25ZM10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10C17.5 14.1421 14.1421 17.5 10 17.5Z"
//                                   fill="#161616"
//                                 />
//                               </svg>
//                             </Box>
//                           ) : (
//                             <Box
//                               onClick={() =>
//                                 handleSelectAnswer(q.questionId, opt)
//                               }
//                               sx={{
//                                 width: "1.09375rem",
//                                 height: "1.09375rem",
//                                 fill: "#0036DD",
//                                 strokeWidth: "2px",
//                                 stroke: "#0036DD",
//                               }}
//                             >
//                               <svg
//                                 xmlns="http://www.w3.org/2000/svg"
//                                 width="20"
//                                 height="20"
//                                 viewBox="0 0 20 20"
//                                 fill="none"
//                               >
//                                 <path
//                                   fillRule="evenodd"
//                                   clipRule="evenodd"
//                                   d="M9.75 1C4.91751 1 1 4.91751 1 9.75C1 14.5825 4.91751 18.5 9.75 18.5C14.5825 18.5 18.5 14.5825 18.5 9.75C18.5 7.42936 17.5781 5.20376 15.9372 3.56282C14.2962 1.92187 12.0706 1 9.75 1ZM9.75 6C7.67893 6 6 7.67893 6 9.75C6 11.8211 7.67893 13.5 9.75 13.5C11.8211 13.5 13.5 11.8211 13.5 9.75C13.5 7.67893 11.8211 6 9.75 6ZM2.25 9.75C2.25 13.8921 5.60786 17.25 9.75 17.25C13.8921 17.25 17.25 13.8921 17.25 9.75C17.25 5.60786 13.8921 2.25 9.75 2.25C5.60786 2.25 2.25 5.60786 2.25 9.75Z"
//                                   fill="#0036DD"
//                                   stroke="#0036DD"
//                                   strokeWidth="2"
//                                 />
//                               </svg>
//                             </Box>
//                           )}
//                           <Typography
//                             sx={{
//                               color: "#000",
//                               //fontFamily: '"Akkurat Pro"',
//                               fontSize: {
//                                 xs: "0.8rem",
//                                 sm: "0.8rem",
//                                 md: "0.8rem",
//                                 lg: "12px",
//                                 xl: "0.9rem",
//                               },
//                               fontStyle: "normal",
//                               fontWeight: 400,
//                               lineHeight: "0.5625rem",
//                               fontFeatureSettings: "'liga' off, 'clig' off",
//                             }}
//                           >
//                             {opt}
//                           </Typography>
//                         </Box>
//                       );
//                     })}
//                   </Box>
//                 </Box>
//               </Box>
//             );
//           })}
//         </Box>
//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             alignSelf: "stretch",
//             gap: "1rem",
//             background: "none",
//           }}
//         >
//           {/* LEFT SIDE → BACK BUTTON */}
//           <Box sx={{ display: "flex", gap: "1rem" }}>
//             <Box
//               onClick={handleBack}
//               sx={{
//                 display: "flex",
//                 width: "6.5rem",
//                 height: "2rem",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 borderRadius: "1.75rem",

//                 // ⭐ Border changes
//                 border:
//                   categoryIndex === 0
//                     ? "1px solid #EDF2FE" // disabled border
//                     : "1px solid #1F2D5C", // enabled border

//                 // ⭐ Background (no fill)
//                 background: categoryIndex === 0 ? "#F8FAFF" : "#FFFFFF",

//                 // ⭐ Text color
//                 color:
//                   categoryIndex === 0
//                     ? "#98A3AD" // disabled text
//                     : "#1F2D5C", // enabled text

//                 cursor: categoryIndex === 0 ? "not-allowed" : "pointer",
//                 fontWeight: 400,
//                 fontSize: {
//                   xs: "0.8rem",
//                   sm: "0.8rem",
//                   md: "0.8rem",
//                   lg: "0.8rem",
//                   xl: "0.9rem",
//                 },
//                 transition: "all 0.3s ease",
//                 fontFamily: "Akkurat",

//                 // ⭐ Hover should NOT change color or fill
//                 "&:hover": {
//                   background: categoryIndex === 0 ? "#F8FAFF" : "#FFFFFF",
//                   color: categoryIndex === 0 ? "#98A3AD" : "#1F2D5C",
//                   border:
//                     categoryIndex === 0
//                       ? "1px solid #EDF2FE"
//                       : "1px solid #1F2D5C",
//                 },
//               }}
//             >
//               Back
//             </Box>
//           </Box>

//           {/* RIGHT SIDE → SAVE + NEXT BUTTONS */}
//           <Box sx={{ display: "flex", gap: "1rem" }}>
//             {/* SAVE (Submit on last page) */}
//             <Box
//               onClick={() => {
//                 if (!canSave) return;

//                 // if (categoryIndex === categories.length - 1) {
//                 // handleSaveOrSubmit("submit");
//                 // } else {
//                 handleSaveOrSubmit("save");
//                 // }
//               }}
//               sx={{
//                 display: "flex",
//                 width: "6.5rem",
//                 height: "2rem",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 borderRadius: "1.75rem",
//                 fontFamily: "Akkurat",

//                 border: "1px solid transparent",

//                 background: "transparent",

//                 color: canSave ? "#1F2D5C" : "#98A3AD",

//                 cursor: canSave ? "pointer" : "not-allowed",

//                 fontWeight: 300,

//                 transition: "all 0.3s ease",

//                 "&:hover": {
//                   border: canSave
//                     ? "1px solid #1F2D5C"
//                     : "1px solid transparent",

//                   color: canSave ? "#1F2D5C" : "#98A3AD",
//                   background: "transparent",
//                 },
//               }}
//             >
//               {/* {categoryIndex === categories.length - 1 ? "Submit" : "Save"} */}
//               Save
//             </Box>

//             {/* NEXT BUTTON */}
//             <Box
//               onClick={handleNextOrWarn}
//               sx={{
//                 display: "flex",
//                 width: "6.5rem",
//                 height: "2rem",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 borderRadius: "1.75rem",
//                 fontFamily: "Akkurat",

//                 border: canMoveNext
//                   ? "1px solid #1F2D5C" // enabled
//                   : "1px solid #EDF2FE", // disabled

//                 background: canMoveNext ? "#FFFFFF" : "#F8FAFF",

//                 color: canMoveNext ? "#1F2D5C" : "#98A3AD",

//                 cursor: canMoveNext ? "pointer" : "not-allowed",

//                 fontWeight: 400,

//                 fontSize: {
//                   xs: "0.8rem",
//                   sm: "0.8rem",
//                   md: "0.8rem",
//                   lg: "0.8rem",
//                   xl: "0.9rem",
//                 },
//                 transition: "all 0.3s ease",

//                 // ⭐ Hover behavior (same as Back)
//                 "&:hover": {
//                   background: canMoveNext ? "#FFFFFF" : "#F8FAFF",
//                   color: canMoveNext ? "#1F2D5C" : "#98A3AD",
//                   border: canMoveNext
//                     ? "1px solid #1F2D5C"
//                     : "1px solid #EDF2FE",
//                 },
//               }}
//             >
//               {/* {categoryIndex === categories.length - 1 ? "Save" : "Next"} */}
//               {categoryIndex === categories.length - 1 ? "Submit" : "Next"}
//             </Box>
//           </Box>
//         </Box>
//       </Box>

//       <SuccessBanner open={showSuccessBanner} message={bannerMessage} />

//       <Notification
//         open={notif.open}
//         success={notif.success}
//         text={notif.text}
//         onClose={() => setNotif((prev) => ({ ...prev, open: false }))}
//       />
//       <GlassLoaderOverlay open={loading} />
//     </Box>
//   );
// };

// export default Questions;



import React, { useState, useEffect, useMemo, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { UnsavedContext } from "../MainLayout";
import CheckIcon from "@mui/icons-material/Check";
import {
  Box,
  Typography,
  Avatar,
  Menu,
  MenuItem,
  Button,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  Paper,
  RadioGroup,
  FormControlLabel,
  Radio,
  Divider,
  Snackbar,
  Alert,
  LinearProgress,
  CircularProgress,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useLocation, useParams } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import { motion, AnimatePresence } from "framer-motion";
import signup from "../../assets/images/background.png";
import Notification from "../Notification";
// import AssessmentDialog from "../AssessmentDialog";
import { useApi } from "../../api/useApi";
import { useAuth } from "../../auth/AuthContext";
import GlassLoaderOverlay from "../GlassLoader";
import { useActiveCategory } from "../customHook/useActiveCategory";

const SuccessBanner = ({ open, message }) => {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 50, opacity: 0 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          style={{
            position: "fixed",
            bottom: "2rem", // stay at bottom
            left: "35%", // center horizontally
            transform: "translateX(-50%)", // perfectly center it
            display: "inline-flex",
            alignItems: "center",
            gap: "1rem",
            borderRadius: "1rem",
            border: "1px solid #00A300",
            background: "#016100",
            color: "#FFFFFF",
            // fontFamily: "Akkurat-Bold, sans-serif",
            fontSize: "0.9rem",
            fontWeight: 400,
            padding: "0.75rem 1.25rem",
            zIndex: 2000,
            boxShadow: "0 2px 10px rgba(0, 0, 0, 0.25)",
            textAlign: "center",
            maxWidth: "90%",
            fontFamily: "Akkurat",
          }}
        >
          {/* ✅ Green Tick Icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10 1.25C5.125 1.25 1.25 5.125 1.25 10C1.25 14.875 5.125 18.75 10 18.75C14.875 18.75 18.75 14.875 18.75 10C18.75 5.125 14.875 1.25 10 1.25ZM8.75 13.75L5.375 10.375L6.5 9.375L8.75 11.625L13.75 6.75L14.875 7.75L8.75 13.75Z"
              fill="#24A148"
            />
          </svg>

          {/* ✅ Message Text */}
          <span>{message}</span>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
const Questions = () => {
  const { domain } = useParams();
  const [categories, setCategories] = useState([]);
  const { request, loading } = useApi();
  const { user } = useAuth();
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [categoryIndex, setCategoryIndex] = useState(0);
  const [categoryStatus, setCategoryStatus] = useState({});
  const [progress, setProgress] = useState(0);
  const [evaluationId, setEvaluationId] = useState(null);
  const [notif, setNotif] = useState({
    open: false,
    success: true,
    text: "",
  });
  const scrollRef = useRef(null);

  const navigate = useNavigate();
  const [showSuccessBanner, setShowSuccessBanner] = useState(false);
  const [bannerMessage, setBannerMessage] = useState("");
  const [dataLoaded, setDataLoaded] = useState(false);
  const { hasUnsaved, setHasUnsaved } = React.useContext(UnsavedContext);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [isCategoriesReady, setIsCategoriesReady] = useState(false);
  const [isLastCategoryReady, setIsLastCategoryReady] = useState(false);
  const activeCategory = useActiveCategory();

  const location = useLocation();

  const {
    resume,
    evaluationId: navEvaluationId,
    categoryIndex: navCategoryIndex,
  } = location.state || {};

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (hasUnsaved) {
        // Show browser default warning popup
        event.preventDefault();
        event.returnValue = "";

        // Show your custom warning banner (bottom red banner)
        setNotif({
          open: true,
          success: false,
          text: "You have unsaved changes. Please click SAVE before continuing.",
        });
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [hasUnsaved]);

  useEffect(() => {
    async function fetchCategories() {
      try {
        const categories = await request({ url: "/domains-with-categories" });
        const categoriesByDomain =
          categories.find((d) => d.name.toLowerCase() === domain.toLowerCase())
            ?.categories || [];
        const sortByWeightage = categoriesByDomain.sort((a, b) => {
          if (b.weightage !== a.weightage) return b.weightage - a.weightage;
          return a.name.localeCompare(b.name);
        });

        setCategories(sortByWeightage);
        setIsCategoriesReady(true);
      } catch (err) {
        console.error("Error fetching categories:", err);
      }
    }

    fetchCategories();
  }, [domain]);

  useEffect(() => {
    async function fetchAllData() {
      try {
        // 🧹 Reset data before loading new domain — but don't reset categoryIndex
        setDataLoaded(false);
        setQuestions([]);
        setAnswers({});
        setProgress(0);
        const storedEvalId = localStorage.getItem(`evaluationId_${domain}`);
        if (storedEvalId) {
          setEvaluationId(storedEvalId);
        }
        // ⭐ Restore evaluationId from localStorage FIRST
        // const storedEvalId = localStorage.getItem("evaluationId");
        if (storedEvalId) {
          setEvaluationId(storedEvalId);
        }

        // Step 1: Fetch user details
        const users = await request({
          url: `/user/by-email?email=${user?.email}`,
        });

        const userRole = users?.[0]?.userRole;
        const userDomain = users?.[0]?.domain;
        const userDomainRole = users?.[0]?.userDomain;
        // Step 2: Fetch questions
        const questionsData = await request({
          url: `/questions/filter?userRole=${encodeURIComponent(
            userRole,
          )}&domain=${encodeURIComponent(domain)}&userDomainRole=${encodeURIComponent(userDomainRole)}`,
        });

        const freshQuestions = questionsData?.questions || [];
        const latestCompletedData = await request({
          url: `/evaluations/latest-completed-answers?emailId=${encodeURIComponent(
            user?.email,
          )}&domain=${encodeURIComponent(domain)}`,
        });

        // Step 3: Fetch resume data
        const resumeData = await request({
          url: `/evaluations/evaluation/progress?emailId=${encodeURIComponent(
            user?.email,
          )}&domain=${encodeURIComponent(domain)}`,
        });

        const savedData =
          latestCompletedData?.found && !resumeData?.resumeAvailable
            ? latestCompletedData
            : resumeData || {};
        const answersMap = {};
        if (latestCompletedData?.found && !resumeData?.resumeAvailable)
          localStorage.setItem(
            `resumeLastCategory_${domain}`,
            latestCompletedData?.allCategories[0],
          );

        if (savedData?.resumeAvailable) {
          localStorage.setItem("resumeAvailable", "true");
        } else {
          localStorage.removeItem("resumeAvailable");
        }

        // Step 4: If resuming, restore previous state
        if (savedData?.questionsByCategory) {
          Object.values(savedData.questionsByCategory).forEach(
            (categoryQuestions) => {
              categoryQuestions.forEach((q) => {
                if (
                  q.questionId &&
                  q.selectedOption !== undefined &&
                  q.selectedOption !== null
                ) {
                  answersMap[q.questionId] = q.selectedOption;
                }
              });
            },
          );

          setEvaluationId(savedData.evaluationId);
          setAnswers(answersMap);

          // Persist which category to land on for a *partial* (SAVED) resume too —
          // previously only the completed-evaluation branch above set this key,
          // so a partial resume with no prior localStorage value fell through to
          // categoryIndex -1 (blank category / no questions rendered).
          if (savedData.lastCategory) {
            localStorage.setItem(
              `resumeLastCategory_${domain}`,
              savedData.lastCategory,
            );
          }

          setIsLastCategoryReady(true);

          // setCategoryIndex(
          //   typeof savedData.categoryIndex === "number"
          //     ? savedData.categoryIndex
          //     : 0
          // );

          console.log(
            "🟢 Resuming evaluation",
            savedData.evaluationId,
            "at category index",
            savedData.categoryIndex,
          );
        } else {
          // New user → start fresh
          setProgress(0);
          setCategoryIndex(0);
        }

        setQuestions(freshQuestions);
      } catch (err) {
        console.error("Error fetching evaluation data:", err);
      } finally {
        setDataLoaded(true);
      }
    }

    if (user?.email && domain) {
      fetchAllData();
    }
  }, [user.email, domain]);
  useEffect(() => {
    if (isCategoriesReady && isLastCategoryReady) {
      const resumeLastCategory = localStorage.getItem(
        `resumeLastCategory_${domain}`,
      );
      let activeStepindex = categories.findIndex(
        (item) => item.name == resumeLastCategory,
      );
      // Guard against a stale/missing localStorage value producing -1 (which
      // previously rendered a blank category page with no questions at all).
      setCategoryIndex(activeStepindex >= 0 ? activeStepindex : 0);
    }
  }, [isCategoriesReady, isLastCategoryReady]);
  useEffect(() => {
    let activeStepindex = categories.findIndex(
      (item) => item.name == activeCategory,
    );
    setCategoryIndex(activeStepindex);
  }, [activeCategory, categories]);
  useEffect(() => {
    if (!questions?.length) return;

    // Group questions by category
    const grouped = questions.reduce((acc, q) => {
      if (!acc[q.category]) acc[q.category] = [];
      acc[q.category].push(q);
      return acc;
    }, {});

    // Calculate status for each category
    const statusMap = {};

    Object.keys(grouped).forEach((category) => {
      const catQuestions = grouped[category];

      const anyAnswered = catQuestions.some(
        (q) =>
          answers[q.questionId] !== undefined && answers[q.questionId] !== "",
      );

      const allAnswered = catQuestions.every(
        (q) =>
          answers[q.questionId] !== undefined && answers[q.questionId] !== "",
      );

      statusMap[category] = { anyAnswered, allAnswered };
    });

    setCategoryStatus(statusMap);
    localStorage.setItem("categoryStatus", JSON.stringify(statusMap));
    window.dispatchEvent(new Event("categoryStatusUpdated"));
  }, [answers, questions]);

  useEffect(() => {
    if (!categories.length || !questions.length) return;

    // Group questions by category
    const grouped = categories.reduce((acc, cat) => {
      acc[cat.name] = questions.filter((q) => q.category === cat.name);
      return acc;
    }, {});

    let totalProgress = 0;
    categories.forEach((cat) => {
      const catQuestions = grouped[cat.name] || [];
      if (catQuestions.length === 0) return;
      const answeredCount = catQuestions.filter(
        (q) => answers[q.questionId],
      ).length;
      const fraction = answeredCount / catQuestions.length;
      totalProgress += fraction * cat.weightage;
    });

    setProgress(Math.round(totalProgress));
  }, [answers, questions, categories]);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [categoryIndex]);

  const currentCategory = categories[categoryIndex];

  useEffect(() => {
    if (!categories.length) return;

    const cat = categories[categoryIndex];
    if (cat) {
      // Save active category
      localStorage.setItem("activeCategory", cat.name);

      // 🔥 Notify MainLayout immediately
      window.dispatchEvent(new Event("activeCategoryChanged"));
    }
  }, [categoryIndex, categories]);

  const currentCategoryQuestions = questions.filter(
    (q) => q.category === currentCategory?.name,
  );

  // ⭐ Add this exactly here
  const totalQuestions = currentCategoryQuestions.length;
  const answeredCount = currentCategoryQuestions.filter(
    (q) => answers[q.questionId],
  ).length;

  const handleSelectAnswer = (questionId, opt) => {
    setAnswers((prev) => ({ ...prev, [questionId]: opt }));
    setHasUnsaved(true);
  };

  const canSave = useMemo(() => {
    if (!currentCategoryQuestions) return false;

    return currentCategoryQuestions.some(
      (q) =>
        answers[q.questionId] !== undefined && answers[q.questionId] !== "",
    );
  }, [answers, currentCategoryQuestions]);

  const canMoveNext = useMemo(() => {
    if (!currentCategoryQuestions || currentCategoryQuestions.length === 0) {
      return true;
    }

    return currentCategoryQuestions.every(
      (q) =>
        answers[q.questionId] !== undefined && answers[q.questionId] !== "",
    );
  }, [answers, currentCategoryQuestions]);

  const handleNext = () => {
    setCategoryIndex((idx) => Math.min(idx + 1, categories.length - 1));
  };
  const handleBack = () => setCategoryIndex((idx) => Math.max(idx - 1, 0));

  const handleSaveOrSubmit = async (actionType = "save") => {
    const activeCategory = localStorage.getItem("activeCategory");
    try {
      let transformedAnswers = [];

      // Transform user answers into backend-friendly format
      questions.forEach((q) => {
        const selectedOption = answers[q.questionId];
        if (selectedOption) {
          const options = q.optionText
            ? q.optionText.split(",").map((opt) => opt.trim())
            : [];
          const pointsArr = q.optionPoints
            ? q.optionPoints.split(",").map((p) => parseFloat(p.trim()))
            : [];
          const recsArr = q.recommendation
            ? q.recommendation.split("||").map((r) => r.trim())
            : [];
          const remarksArr = q.remarks
            ? q.remarks.split(",").map((r) => r.trim())
            : [];
          const optionIndex = options.indexOf(selectedOption);

          transformedAnswers.push({
            questionId: q.questionId,
            selectedOption,
            points:
              optionIndex !== -1 && pointsArr.length > optionIndex
                ? pointsArr[optionIndex]
                : 0,
            recommendation:
              optionIndex !== -1 && recsArr.length > optionIndex
                ? recsArr[optionIndex]
                : "not provided",
            remarks:
              optionIndex !== -1 && remarksArr.length > optionIndex
                ? remarksArr[optionIndex]
                : "",
            //domain: domain,
            domain: domain.toUpperCase(),
            category: q.category || "Uncategorized",
          });
        }
      });

      // Prepare payload
      const payload = {
        emailId: user.email,
        userName: user.name,
        evaluationId: evaluationId,
        answers: transformedAnswers,
        isLastCategory: categoryIndex === categories.length - 1,
        isSubmitAction: actionType === "submit",
        currentCategory: activeCategory,
        // ✅ ADD THESE TWO LINES
        submittedAt: new Date().toLocaleString("sv-SE").replace(" ", "T"), // "2024-01-15T10:01:00"
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };
      // Save or submit to backend
      const response = await request({
        url: `/evaluations/saveOrSubmit`,
        method: "POST",
        data: payload,
      });

      console.log("SAVE/SUBMIT RESPONSE →", response);

      if (response?.evaluationId) {
        setEvaluationId(response.evaluationId);
        localStorage.setItem(`evaluationId_${domain}`, response.evaluationId);
      }

      const finalEvalId =
        response?.evaluationId !== undefined && response?.evaluationId !== null
          ? response.evaluationId
          : evaluationId;

      if (actionType === "submit") {
        setBannerMessage(
          "Congratulations! Your form has been successfully submitted for assessment.",
        );
        setShowSuccessBanner(true);

        setTimeout(() => {
          setShowSuccessBanner(false);

          navigate(
            `/final-page?evaluationId=${
              response?.evaluationId || evaluationId
            }&domain=${encodeURIComponent(domain)}&email=${encodeURIComponent(
              user.email,
            )}&name=${encodeURIComponent(user.name || "User")}`,
          );
        }, 2500);
      } else {
        setBannerMessage(
          "Answers saved successfully. You can resume your assessment within 30 days. Thank you.",
        );
        setShowSuccessBanner(true);
        setTimeout(() => setShowSuccessBanner(false), 3000);
      }

      setHasUnsaved(false);
    } catch (error) {
      console.error("Error saving or submitting:", error);
    }
  };

  if (!dataLoaded) {
    return <GlassLoaderOverlay open={true} />; // show spinner
  }

  if (dataLoaded && (!categories.length || !questions.length)) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "70vh",
          borderRadius: "2.5rem",
          background: "rgba(255, 255, 255, 0.7)",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Akkurat-Bold",
            fontSize: "1.25rem",
            color: "#0036DD",
            textAlign: "center",
          }}
        >
          Assessment not available
        </Typography>
      </Box>
    );
  }

  const handleNextOrWarn = () => {
    if (!canMoveNext) {
      const unanswered = currentCategoryQuestions
        .filter((q) => !answers[q.questionId])
        .map(
          (q) =>
            currentCategoryQuestions.findIndex(
              (i) => i.questionId === q.questionId,
            ) + 1,
        )
        .join(", ");

      setNotif({
        open: true,
        success: false,
        text: `Please answer all questions. Unanswered: Q${unanswered}`,
      });
      return;
    }

    if (categoryIndex === categories.length - 1 && canMoveNext) {
      handleSaveOrSubmit("submit");
      return;
    }

    // 3) Otherwise, move to next category
    if (canMoveNext) {
      handleNext();
      return;
    }

    // 4) Fallback: warn about unsaved changes (if any)
    if (hasUnsavedChanges) {
      setNotif({
        open: true,
        success: false,
        text: "You have unsaved changes. Please click SAVE before continuing.",
      });
      return;
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: { xs: "1rem", sm: "1.25rem", md: "1rem" },
        flex: "1 0 0",
        borderRadius: { xs: "0.75rem", sm: "1rem", md: "1.25rem" },
        height: { xs: "70vh", sm: "70vh", md: "70vh", lg: "84vh", xl: "86vh" },
        border: "1px solid #ECECEC",
        background: "#FFF",
        margin: "20px",

        padding: { xs: 0, sm: 0, md: 0, lg: 0, xl: 3 },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: "1rem",
          padding: "1rem",
          alignSelf: "stretch",
          borderRadius: "2rem",
          background: "rgba(255, 255, 255, 0.70)",
          // height: "59vh",
          // overflowY: "scroll", scrollbarWidth: "none",
        }}
      >
        {/* Steps Of Categories*/}

        <Box
          sx={{
            display: "flex",
            padding: "0.75rem 1.5rem",
            alignItems: "center",
            gap: "1rem",
            alignSelf: "stretch",
            borderRadius: "0.5rem",
            background: "var(--Background-Background-information, #EDF0FD)",
          }}
        >
          <Typography
            sx={{
              color: "#0036DD",
              fontFeatureSettings: "'liga' off, 'clig' off",
              fontFamily: "Akkurat-Pro",
              fontSize: {
                xs: "0.9rem",
                sm: "0.9rem",
                md: "0.9rem",
                lg: "1rem",
                xl: "1rem",
              },
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "normal",
            }}
          >
            Category :&nbsp;
            <Box
              component="span"
              sx={{
                color: "#0036DD",
                fontFeatureSettings: "'liga' off, 'clig' off",
                fontSize: {
                  xs: "0.9rem",
                  sm: "0.9rem",
                  md: "0.9rem",
                  lg: "1rem",
                  xl: "1rem",
                },
                fontFamily: "Akkurat-Bold",
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "normal",
              }}
            >
              {currentCategory?.name}

              {/* {currentCategory?.name} - ({answeredCount}/{totalQuestions}) */}
            </Box>
          </Typography>
        </Box>

        {/* Questions */}
        <Box
          ref={scrollRef}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",

            width: {
              xs: "100%",
              sm: "100%",
              md: "85%",
              lg: "100%",
              xl: "100%",
            },

            // maxWidth: "100%",

            // width: "100%",
            height: {
              xs: "53vh",
              sm: "53vh",
              md: "53vh",
              lg: "60vh",
              xl: "70vh",
            },

            overflowY: "auto",
            overflowX: "hidden",

            "&::-webkit-scrollbar": {
              width: "2px",
            },
            "&::-webkit-scrollbar-track": {
              background: "transparent",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "rgba(0, 0, 0, 0.50)",
              borderRadius: "1rem",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              background: "rgba(0, 0, 0, 0.50)",
            },
          }}
        >
          {currentCategoryQuestions.map((q, idx) => {
            const options = q.optionText.split(",");
            const isAnswered = answers[q.questionId] !== undefined;
            return (
              <Box
                key={q.questionId}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "0.5rem",
                  alignSelf: "stretch",
                  // pl: { xs: 3, sm: 3, md: 3, lg: 0, xl: 3 },
                }}
              >
                <Box
                  sx={{
                    width: "0.125rem",
                    alignSelf: "stretch",
                    background: isAnswered
                      ? "#0036DD"
                      : "var(--border-border-subtle-01, #E0E0E0)",
                  }}
                />

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "1rem",
                    paddingBottom: "1.5rem",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      alignSelf: "stretch",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        height: "1.125rem",
                        marginBottom: "0.5rem",
                      }}
                    >
                      <Typography
                        sx={{
                          //color: "var(--text-text-primary, #161616)",
                          color: "#525252",
                          fontSize: {
                            xs: "0.9rem",
                            sm: "0.9rem",
                            md: "0.9rem",
                            lg: "16px",
                            xl: "1rem",
                          },
                          fontFamily: "Akkurat",
                          //fontSize: "0.875 rem",
                          fontStyle: "normal",
                          fontWeight: 400,
                          lineHeight: "1.125rem",
                          fontFeatureSettings: "'liga' off, 'clig' off",
                        }}
                      >
                        {` ${idx + 1}. `}
                        {q.question}
                      </Typography>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      gap: "1rem",
                      height: "fit-content",
                      alignSelf: "stretch",
                    }}
                  >
                    {options.map((opt) => {
                      const isSelected = answers[q.questionId] === opt;
                      return (
                        <Box
                          key={opt}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.5rem",
                            fontFamily: "Akkurat-Pro",
                          }}
                        >
                          {!isSelected ? (
                            <Box
                              onClick={() =>
                                handleSelectAnswer(q.questionId, opt)
                              }
                              sx={{
                                width: "1.25rem",
                                height: "1.25rem",
                                flexShrink: 0,
                                m: 0,
                                p: 0,
                                cursor: "pointer",
                              }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M10 1.25C5.16751 1.25 1.25 5.16751 1.25 10C1.25 14.8325 5.16751 18.75 10 18.75C14.8325 18.75 18.75 14.8325 18.75 10C18.75 7.67936 17.8281 5.45376 16.1872 3.81282C14.5462 2.17187 12.3206 1.25 10 1.25ZM10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10C17.5 14.1421 14.1421 17.5 10 17.5Z"
                                  fill="#161616"
                                />
                              </svg>
                            </Box>
                          ) : (
                            <Box
                              onClick={() =>
                                handleSelectAnswer(q.questionId, opt)
                              }
                              sx={{
                                width: "1.09375rem",
                                height: "1.09375rem",
                                fill: "#0036DD",
                                strokeWidth: "2px",
                                stroke: "#0036DD",
                              }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M9.75 1C4.91751 1 1 4.91751 1 9.75C1 14.5825 4.91751 18.5 9.75 18.5C14.5825 18.5 18.5 14.5825 18.5 9.75C18.5 7.42936 17.5781 5.20376 15.9372 3.56282C14.2962 1.92187 12.0706 1 9.75 1ZM9.75 6C7.67893 6 6 7.67893 6 9.75C6 11.8211 7.67893 13.5 9.75 13.5C11.8211 13.5 13.5 11.8211 13.5 9.75C13.5 7.67893 11.8211 6 9.75 6ZM2.25 9.75C2.25 13.8921 5.60786 17.25 9.75 17.25C13.8921 17.25 17.25 13.8921 17.25 9.75C17.25 5.60786 13.8921 2.25 9.75 2.25C5.60786 2.25 2.25 5.60786 2.25 9.75Z"
                                  fill="#0036DD"
                                  stroke="#0036DD"
                                  strokeWidth="2"
                                />
                              </svg>
                            </Box>
                          )}
                          <Typography
                            sx={{
                              color: "#000",
                              //fontFamily: '"Akkurat Pro"',
                              fontSize: {
                                xs: "0.8rem",
                                sm: "0.8rem",
                                md: "0.8rem",
                                lg: "12px",
                                xl: "0.9rem",
                              },
                              fontStyle: "normal",
                              fontWeight: 400,
                              lineHeight: "0.5625rem",
                              fontFeatureSettings: "'liga' off, 'clig' off",
                            }}
                          >
                            {opt}
                          </Typography>
                        </Box>
                      );
                    })}
                  </Box>
                </Box>
              </Box>
            );
          })}
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            alignSelf: "stretch",
            gap: "1rem",
            background: "none",
          }}
        >
          {/* LEFT SIDE → BACK BUTTON */}
          <Box sx={{ display: "flex", gap: "1rem" }}>
            <Box
              onClick={handleBack}
              sx={{
                display: "flex",
                width: "6.5rem",
                height: "2rem",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "1.75rem",

                // ⭐ Border changes
                border:
                  categoryIndex === 0
                    ? "1px solid #EDF2FE" // disabled border
                    : "1px solid #1F2D5C", // enabled border

                // ⭐ Background (no fill)
                background: categoryIndex === 0 ? "#F8FAFF" : "#FFFFFF",

                // ⭐ Text color
                color:
                  categoryIndex === 0
                    ? "#98A3AD" // disabled text
                    : "#1F2D5C", // enabled text

                cursor: categoryIndex === 0 ? "not-allowed" : "pointer",
                fontWeight: 400,
                fontSize: {
                  xs: "0.8rem",
                  sm: "0.8rem",
                  md: "0.8rem",
                  lg: "0.8rem",
                  xl: "0.9rem",
                },
                transition: "all 0.3s ease",
                fontFamily: "Akkurat",

                // ⭐ Hover should NOT change color or fill
                "&:hover": {
                  background: categoryIndex === 0 ? "#F8FAFF" : "#FFFFFF",
                  color: categoryIndex === 0 ? "#98A3AD" : "#1F2D5C",
                  border:
                    categoryIndex === 0
                      ? "1px solid #EDF2FE"
                      : "1px solid #1F2D5C",
                },
              }}
            >
              Back
            </Box>
          </Box>

          {/* RIGHT SIDE → SAVE + NEXT BUTTONS */}
          <Box sx={{ display: "flex", gap: "1rem" }}>
            {/* SAVE (Submit on last page) */}
            <Box
              onClick={() => {
                if (!canSave) return;

                // if (categoryIndex === categories.length - 1) {
                // handleSaveOrSubmit("submit");
                // } else {
                handleSaveOrSubmit("save");
                // }
              }}
              sx={{
                display: "flex",
                width: "6.5rem",
                height: "2rem",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "1.75rem",
                fontFamily: "Akkurat",

                border: "1px solid transparent",

                background: "transparent",

                color: canSave ? "#1F2D5C" : "#98A3AD",

                cursor: canSave ? "pointer" : "not-allowed",

                fontWeight: 300,

                transition: "all 0.3s ease",

                "&:hover": {
                  border: canSave
                    ? "1px solid #1F2D5C"
                    : "1px solid transparent",

                  color: canSave ? "#1F2D5C" : "#98A3AD",
                  background: "transparent",
                },
              }}
            >
              {/* {categoryIndex === categories.length - 1 ? "Submit" : "Save"} */}
              Save
            </Box>

            {/* NEXT BUTTON */}
            <Box
              onClick={handleNextOrWarn}
              sx={{
                display: "flex",
                width: "6.5rem",
                height: "2rem",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "1.75rem",
                fontFamily: "Akkurat",

                border: canMoveNext
                  ? "1px solid #1F2D5C" // enabled
                  : "1px solid #EDF2FE", // disabled

                background: canMoveNext ? "#FFFFFF" : "#F8FAFF",

                color: canMoveNext ? "#1F2D5C" : "#98A3AD",

                cursor: canMoveNext ? "pointer" : "not-allowed",

                fontWeight: 400,

                fontSize: {
                  xs: "0.8rem",
                  sm: "0.8rem",
                  md: "0.8rem",
                  lg: "0.8rem",
                  xl: "0.9rem",
                },
                transition: "all 0.3s ease",

                // ⭐ Hover behavior (same as Back)
                "&:hover": {
                  background: canMoveNext ? "#FFFFFF" : "#F8FAFF",
                  color: canMoveNext ? "#1F2D5C" : "#98A3AD",
                  border: canMoveNext
                    ? "1px solid #1F2D5C"
                    : "1px solid #EDF2FE",
                },
              }}
            >
              {/* {categoryIndex === categories.length - 1 ? "Save" : "Next"} */}
              {categoryIndex === categories.length - 1 ? "Submit" : "Next"}
            </Box>
          </Box>
        </Box>
      </Box>

      <SuccessBanner open={showSuccessBanner} message={bannerMessage} />

      <Notification
        open={notif.open}
        success={notif.success}
        text={notif.text}
        onClose={() => setNotif((prev) => ({ ...prev, open: false }))}
      />
      <GlassLoaderOverlay open={loading} />
    </Box>
  );
};

export default Questions;